import { cn } from "@gettactic/helpers";
import { forwardRef } from "react";
import { sizeVariants } from "./constants";

interface CustomInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size"> {
  size?: keyof typeof sizeVariants;
  isDragging?: boolean;
}

export const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
  ({ className, size = "default", isDragging = false, ...props }, ref) => {
    return (
      <input
        type="number"
        className={cn(
          // Base styles
          "w-full rounded-md transition-all duration-150",
          "bg-background-primary text-neutral-900 [font-variant-numeric:tabular-nums]",
          // Border and focus states
          "border border-neutral-200",
          "outline-none",
          "hover:border-neutral-300",
          "focus:border-blue-500",
          isDragging && "border-blue-500",
          // Hide spinner buttons
          "[appearance:textfield]",
          "[&::-webkit-outer-spin-button]:appearance-none",
          "[&::-webkit-inner-spin-button]:appearance-none",
          // Size variant
          sizeVariants[size],
          // Group hover state for dropdown button
          "group-hover:pr-9",
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);

CustomInput.displayName = "CustomInput";
